import { Enabling } from '@core/models/enabling.model';
import { ExternalWs } from '@core/models/external-ws.model';
import { Procedure } from '@core/models/procedures.model';
import { WorkGroup } from '@core/models/work-unit.model';
import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { coreActions } from './core.actions';
import { CoreCacheState, CoreState } from './core.models';

export const coreFK = 'coreModule';

const adaptersMap = new Map<keyof CoreCacheState, EntityAdapter<any>>([
  ['enablings', createEntityAdapter<Enabling>()],
  ['externalWs', createEntityAdapter<ExternalWs>()],
  ['procedures', createEntityAdapter<Procedure>()],
  ['workGroups', createEntityAdapter<WorkGroup>()]
]);

export const getCacheAdapter = (key: keyof CoreCacheState) => {
  const adapter = adaptersMap.get(key);
  if (adapter) {
    return adapter;
  } else {
    throw new Error('Core cache key not valid');
  }
};

export const initialState: CoreState = {
  cache: {
    enablings: getCacheAdapter('enablings').getInitialState(),
    externalWs: getCacheAdapter('externalWs').getInitialState(),
    procedures: getCacheAdapter('procedures').getInitialState(),
    workGroups: getCacheAdapter('workGroups').getInitialState(),
  }
};

const cacheReducer = (state: CoreCacheState, key: keyof CoreCacheState, payload: any[]) => ({
  ...state, ...{ [key]: getCacheAdapter(key).upsertMany(payload, state[key]) }
});

const coreReducer = createReducer(
  initialState,
  on(coreActions.stateLoaded, (state, { currentUser, accessToken }) => ({ ...state, currentUser, accessToken })),

  on(coreActions.loggedIn, (state, { user, accessToken }) => ({ ...state, currentUser: user, accessToken })),
  on(coreActions.loggedOut, state => ({ ...state, currentUser: undefined, accessToken: undefined })),

  on(coreActions.cached, (state, { key, payload }) => ({ ...state, cache: cacheReducer(state.cache, key, payload) })),
);

export function reducer(state: CoreState | undefined, action: Action) {
  return coreReducer(state, action);
}
